export default {
  integrations: {
    web: "网站集成",
    webEmbed: "网页嵌入",
    webEmbedTip: "打造你的网页客服机器人",
    clientNumberExceededTip: "该渠道客户端数量超出，详情请咨询产品顾问",
    requiresUpgradeToProVersionForIntegration: "需升级至{version}版本",
    needUpgradeTo: "需升级至",
    use: "使用",
    connect: "托管",
    detailsPleaseConsult: "，详情请咨询产品顾问",
    selfBuildStep: "自建接入步骤",
    customerOperation: "客户运营",
    discord: "在Discord中接入智能回复",
    telegram: "在Telegram中接入智能回复",
    hubspot: "在Hubspot中接入智能回复",
    whatsapp: "在Whatsapp中接入智能回复",
    selfBuild: "自建",
    hosting: "托管",
    TheNumberofClients: "该渠道客户端数量",
    Client: "客户端",
    exceeded: "超出",
    exceededTip: "该渠道客户端数量超出",
    collaborationOffice: "协同办公",
    integrationIntelligentReply: "在Slack中接入智能回复",
    ThisChannel1: "该渠道",
    clients1: "客户端",
    forThisChannelExceeds1: "数量超出",
    basicInformation: "基本信息",
    configurationInformation: "配置信息",
    bindClient: "绑定客户端",
    configureClient: "配置客户端",
    selectYourDefaultApplication: "选择你的默认应用",
    pleaseEnter: "请输入",
    copy: "复制",
    discordInvite: "在Discord中打开",
    createCompleted: "创建完成，点击「确定」前往客户端管理进行详细配置。",
    accessCompleted: "接入完成，可前往「客户端管理」进行详细配置与管理。",
    nextStep: "下一步",
    pleaseFillIn: "请填写",
    bindSuccess: "绑定成功",
    app: "应用",
    workflow: "工作流",
    dialogApi: "对话 API",
    dialogApiTip: "将应用或工作流的对话能力接入你的应用",
    dialogApiMemory: "带记忆的对话 API",
    dialogApiMemoryTip:
      "兼容应用和工作流中的上下文记忆设置，无需单独传入上下文",
    workflowRunApi: "工作流运行 API",
    workflowRunApiTip: "可传入工作流变量运行工作流",
    APIKeyManagement: "API Key 管理",
    createAPIKey: "创建API Key",
    createTime: "创建时间",
    activeTime: "活跃时间",
    confirmDelete: "是否确认删除此AppKey?",
    confirmDeleteTip: "删除后，该AppKey将无法使用",
    transferToHuman: "转人工设置",
  },
};
